const shippingAddress = require('./shipping-address');

module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        shippingMemberId: {
            type: ['string', 'null']
        },
        type: {
            type: 'string'
        },
        pickupId: {
            type: ['string', 'null']
        },
        pickupLocker: {
            type: ['string', 'null']
        },
        carrierCode: {
            type: ['string', 'null']
        },
        shippingAddress: shippingAddress,
        addressType: {
            type: ['string', 'null']
        }
    }
};
